import { useStatQuery } from '@famly/stat_use-stat-query';
import { ChildCheckinDetail } from './child-checkin-detail.query';
/**
 * Fetches a single check-in together with its KinderConnect capture media (photo, signature,
 * lat/long), if any was captured and the viewer is authorized to see it. Feed the result into
 * `useKinderConnectCaptureDetail` from `@famly/stat_kinder-connect-capture_business-logic` rather
 * than reading `data` directly.
 *
 * @param options - Apollo query options; must include `variables: {childCheckinId}`.
 * @returns The query result, with `data.attendance.childCheckins.byId` holding the check-in
 * detail once loaded.
 */
export function useChildCheckinDetailQuery(options) {
    return useStatQuery(ChildCheckinDetail, options);
}
